import { app } from '../../../../../app';
import { Controller } from './directory-manage-main.controller';

app.component('companyDirectoryIntegrationManageMain', {
    bindings: {
        companyId: '<',
        directory: '<',
        rootDomain: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage-main.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/main/directory-manage-main.component.js